import { render, staticRenderFns } from "./sme-premium-form.vue?vue&type=template&id=f9757504&scoped=true&"
import script from "./sme-premium-form.vue?vue&type=script&lang=js&"
export * from "./sme-premium-form.vue?vue&type=script&lang=js&"
import style0 from "./sme-premium-form.vue?vue&type=style&index=0&id=f9757504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9757504",
  null
  
)

export default component.exports